import React from 'react';
import sortBy from 'lodash/sortBy';
import { FormattedMessage } from 'react-intl';
import { Form } from 'components';
import { useIntl } from 'hooks';

interface Props<FilterKey extends string> {
  publishers: {
    id: number;
    name: string;
    image?: string;
  }[];
  label: string;
  placeholder?: string;
  filterKey: FilterKey;
  filter: { [key in FilterKey]: number[] };
  updateFilter: (changes: {}) => void;
  children?: React.ReactNode;
  boldLabel?: boolean;
}

export default function PublisherFilter<FilterKey extends string>(
  props: Props<FilterKey>
) {
  const {
    publishers,
    label,
    placeholder,
    filterKey,
    filter,
    updateFilter,
    children,
    boldLabel,
  } = props;
  const value = filter[filterKey];
  const { t } = useIntl();
  const options = sortBy(publishers, 'name').map((publisher) => ({
    value: publisher.id,
    label: publisher.name,
    image: publisher.image,
  }));

  return (
    <Form.Field>
      <Form.Label bold={boldLabel}>
        <FormattedMessage id={label} />
      </Form.Label>

      <Form.Select
        isMulti
        onChange={(val) => updateFilter({ [filterKey]: val as number[] })}
        value={value}
        options={options.filter((option) => !!option.label)}
        isClearable={false}
        placeholder={t(
          placeholder || 'MediaLibraryPublisherFilter__Placeholder'
        )}
      />

      {children}
    </Form.Field>
  );
}

PublisherFilter.defaultProps = {
  boldLabel: true,
};
